import { render, staticRenderFns } from "./ProjectStats.vue?vue&type=template&id=3b834b77"
import script from "./ProjectStats.vue?vue&type=script&lang=ts"
export * from "./ProjectStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports